import { useState } from 'react'
import { Link } from 'react-router-dom'

function CardNominee({data, hideBtn}) {
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <div className='cardNominee group flex flex-col shadow-medium hover:shadow-strong m-3 overflow-hidden mb-5 w-11/12 md:w-68 lg:w-64 rounded-2xl bg-white border border-gray-100 hover:-translate-y-2 transition-all duration-300 animate-scale-in'>
          <div className='cardImg h-52 w-full overflow-hidden relative bg-gray-100'>
              {imageError || !data.imageUrl ? (
                <div className='w-full h-full flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200'>
                  <div className='text-center'>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-20 w-20 mx-auto mb-2 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                    <p className='text-gray-500 text-sm font-medium'>No Image</p>
                  </div>
                </div>
              ) : (
                <img
                  className='img-fit w-full h-full block object-cover object-top group-hover:scale-110 transition-transform duration-500'
                  loading='eager'
                  src={data.imageUrl}
                  alt={data.name}
                  onError={handleImageError}
                />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </div>

          <div className='flex flex-col items-center w-full text-center py-4 px-3'>
             <h3 className='text-dark-800 font-bold text-lg mb-1'>
               {data.name + ' (' + data.spName + ')'}
             </h3>
             <p className='text-primary-600 font-semibold text-sm bg-primary-50 px-3 py-1 rounded-full'>
               {data.code}
             </p>
          </div>

          <div className='text-center py-4 bg-gradient-to-br from-gray-50 to-white'>
              <div className="inline-flex flex-col items-center bg-white rounded-xl px-6 py-3 shadow-soft">
                <p className='text-3xl font-bold text-primary-600'>{data.totalVotes}</p>
                <p className='text-xs text-dark-500 font-semibold uppercase tracking-wide'>Votes</p>
              </div>
          </div>

          {
            !hideBtn && <Link to={`/nominee/${data.id}`} className='w-full'>
              <button className='w-full text-white text-center font-bold rounded-b-2xl py-3 bg-gradient-primary hover:shadow-glow transition-all duration-300 transform hover:scale-[1.02]'>
                VOTE NOW
              </button>
            </Link>
          }
    </div>
  )
}

export default CardNominee;